export default __webpack_public_path__ + "static/media/blue-loader.249140da.svg";